import {
  getDiscount,
  getItemCategory,
  getItemCategory2,
  normalizeBrand,
} from '../../utils';

export async function itemsFromPDP(context: Record<string, any>) {
  const { item, value, brand } = context;

  return [
    {
      price: value || 0,
      quantity: 1,
      item_ref: item?.ref || item?.additionalProperty?.find((i: { name: string }) => i.name === "RefId").value || item?.productReference || null,
      item_brand: item.isNotFarm ? item?.item_brand : normalizeBrand(item?.brand.name) || normalizeBrand(brand) || null,
      item_name: item?.productName || item?.alternateName || null,
      item_category: getItemCategory(item) || null,
      item_variant: item?.name?.split("-")[0].trim() || null,
      item_category2: getItemCategory2(item) || item?.category?.split(">")[1]?.trim() || null,
      item_id: item?.productID || item?.productId || item?.item_group_id || null,
      discount: getDiscount(item) || null,

      // dito params view_item
      item_sku: item?.sku || item?.productId || null,
      item_url: item?.url || item?.item_url || item?.link || null,
      seller_id: item?.seller || null
    },
  ];
}
